module.exports = __webpack_public_path__ + "static/media/tm6_7.770101d2.svg";